import React, { Fragment, useEffect, useState } from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Gallery from "../component/Gallery";
import CTA from "../component/CTA";
import Footer from "../component/Footer";
import { HiArrowUpRight, HiChevronDown, HiChevronUp } from "react-icons/hi2";
import { Dialog, Transition } from "@headlessui/react";
import { RxCross1 } from "react-icons/rx";
import Marquee from "react-fast-marquee";
import Modal from "../component/Modal";

export default function About1() {
  const [boxHeight, setBoxHeight] = useState("screen");
  const [readmore, setReadmore] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [type, setType] = useState("");
  const [openDialog, setOpenDialog] = useState(false);

  const ChangeHeight = () => {
    setReadmore(!readmore);
  };

  useEffect(() => {
    if (readmore === true) {
      setBoxHeight("max");
    } else {
      setBoxHeight("screen");
    }
  });

  const tutor = [
    {
      name: "ดร. วรเดช พูนคำ",
      nickname: "ครูเติม",
      subject: "ฟิสิกส์และเคมี",
      imageUrl: "./img/kruterm.png",
      modalImg: "./img/kruterm_info.jpg",
    },
    {
      name: "ครู วิธิวัสส์ ปราณสิริจิรภาส",
      nickname: "ครูบิ๊ก",
      subject: "ภาษาอังกฤษ",
      imageUrl: "./img/krubig.png",
      modalImg: "./img/krubig_info.jpg",
    },
    {
      name: "ครู ศรัญย์ อินทะผิว",
      nickname: "ครูพี",
      subject: "คณิตศาสตร์",
      imageUrl: "./img/krupee.png",
      modalImg: "./img/krupee_info.jpg",
    },

    {
      name: "ดร. กิตต์ ปัญญารัตน์",
      nickname: "ครูกิตต์",
      subject: "เคมี",
      imageUrl: "./img/krukit.png",
      modalImg: "./img/krukit_info.jpg",
    },
    {
      name: "ดร. สาริทธิ์ จารุชัยบวร",
      nickname: "ครูมีน",
      subject: "ชีวะ",
      imageUrl: "./img/krumean.png",
      modalImg: "./img/krumean_info.jpg",
    },
    {
      name: "ดร. วีระวัฒน์ คลอวุฒิมันตร์",
      nickname: "ครูวี",
      subject: "คณิตศาสตร์",
      imageUrl: "./img/kruwee.png",
      modalImg: "./img/kruwee_info.jpg",
    },

    // More people...
  ];
  return (
    <div>
      <div className=" py-24 md:py-32">
        <div className="mx-auto max-w-screen-2xl px-6 lg:px-8">
          <div className="mx-auto max-w-7xl">
            <h2 className=" my-5 mx-auto max-w-max rounded-full bg-slate-100 px-5 py-1 text-center text-2xl font-extrabold  text-purple-500">
              About Us
            </h2>
            <p className="mx-auto hidden max-w-5xl text-center text-6xl   font-extrabold leading-tight tracking-tight text-gray-800 sm:block sm:text-7xl 2xl:text-9xl">
              เกี่ยวกับพวกเรา
            </p>
            <p className="mx-auto max-w-5xl text-center text-6xl   font-extrabold leading-tight tracking-tight text-gray-800 sm:hidden sm:text-9xl">
              เกี่ยวกับเรา
            </p>
          </div>
          <div className="mt-14">
            <OwlCarousel
              className="owl-theme teaching container mx-auto overflow-hidden "
              margin={80}
              items={1}
              // stagePadding={70}
              autoplayHoverPause
              autoplay
              navText={[
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>',
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>',
              ]}
              nav
            >
              <img src="./img/banner1.jpg" className="rounded-3xl" />
              <img src="./img/banner2.jpg" className="rounded-3xl" />
              <img src="./img/banner3.jpg" className="rounded-3xl" />
            </OwlCarousel>
          </div>
        </div>
      </div>

      <div
        className=" mt-[-230px] bg-white pt-[230px] pb-24 sm:mt-[-500px] sm:pt-[500px] sm:pb-32"
        id="intro"
      >
        <div className="mx-auto max-w-7xl px-6">
          <div className="mt-8 grid  gap-10 md:grid-cols-4">
            <div>
              <img
                src="./img/termx2.png"
                className="mx-auto hidden sm:block sm:w-full"
                alt=""
              />
            </div>
            <div className="col-span-3">
              <h2 className=" my-2 mx-auto inline-block rounded-full bg-slate-100 px-5 py-1 text-2xl font-extrabold  text-purple-500">
                Introducing
              </h2>
              <p className="mt-2 max-w-3xl text-5xl font-extrabold leading-tight tracking-tight text-gray-800 sm:text-7xl 2xl:text-8xl">
                ทำความรู้จักกับ
                <br />
                <span className="text-purple-500">กาลิเลโอ ติวเตอร์</span>
              </p>
              <p className="pt-6 pb-4 text-2xl text-gray-600">
                กาลิเลโอติวเตอร์เป็นสถาบันสอนพิเศษที่เน้นการสอนส่วนตัวโดยเปิดมาตั้งแต่
                มิถุนายน พ.ศ. 2555 ที่ U-Center
                ใต้หอพักจุฬาลงกรณ์มหาวิทยาลัย ปัจจุบัน office
                ของทางสถาบันอยู่ที่ สุขสวัสดิ์ 39
                โดยหลักการของทางทีมงานกาลิเลโอติวเตอร์เราเชื่อมั่นว่าการเรียนส่วนตัวจะทำให้ครูถ่ายทอดความรู้ที่มีประสิทธิภาพให้กับนักเรียนได้มากที่สุดและสามารถทำให้นักเรียนโฟกัสในสิ่งต้องเรียนได้มากที่สุด
              </p>
              <p className="py-4 text-2xl text-gray-600">
                ปัจจุบันทางสถาบันได้เปิดสอนแบบ online เต็มรูปแบบในวิชา
                คณิตศาสตร์ เคมี ฟิสิกส์ ชีววิทยา และ ภาษาอังกฤษ
                โดยเน้นในหลักสูตรInternational : IGCSE GCSE A-LEVEL IB AP SAT
                เป็นหลัก
                โดยครูที่จะทำการสอนที่สถาบันจะต้องมีประสบการณ์ในการสอนในวิชานั้น
                ๆ หรือจบการศึกษาขั้นต่ำในระดับปริญญาโท
                และครูทุกคนยังจำเป็นต้องสอบผ่านข้อสอบของทางสถาบันเพื่อให้ครูสามารถสอนได้ตรงตาม
                Course Syllabus และ mark screen
                นอกจากนี้ทางทีมงานกาลิเลโอติวเตอร์เชื่อว่าครูที่สอนน้อง ๆ
                จะสามารถใช้ความรู้ความสามารถในสาขาที่เรียนมาเพื่อใช้แนะแนวสาขาวิชาให้กับน้อง
                ๆ เพื่อให้น้อง ๆ ชื่นชอบวิชานั้น ๆ ได้มากขึ้นอีกด้วย
              </p>
            </div>
          </div>
        </div>
        {/* <Marquee pauseOnHover>
       
            <img src="./gallery/0.jpg" className="mx-5 rounded-3xl" alt="" />
            <img src="./gallery/1.jpg" className="mx-5 rounded-3xl" alt="" />
        </Marquee> */}
      </div>

      <div className="bg-slate-100 py-24 sm:py-32 ">
        <div className="mx-auto max-w-screen-2xl px-6 lg:px-8">
          <h2 className=" my-5 mx-auto max-w-max rounded-full bg-white px-5 py-1 text-2xl font-extrabold  text-purple-500">
            Our Tutors
          </h2>
          <p className="mx-auto mt-2 max-w-3xl text-center text-5xl font-extrabold leading-tight tracking-tight text-gray-800 sm:text-7xl 2xl:text-8xl">
            ติวเตอร์ของเรา
          </p>

          <div className="mt-10 hidden gap-10 sm:grid sm:grid-cols-2 lg:grid-cols-3">
            {tutor.map((person) => (
              <div className="relative rounded-3xl bg-slate-200">
                <img src={person.imageUrl} className="mx-auto" alt="" />
                <div className="absolute -bottom-7 left-5 max-w-xs rounded-lg bg-white p-5 shadow-md sm:static md:max-w-none xl:absolute xl:max-w-xs">
                  <p className="max-w-max rounded-full bg-purple-500 px-2 text-lg text-white">
                    {person.subject}
                  </p>

                  <h1 className="mt-3 text-3xl font-extrabold text-gray-800">
                    {person.nickname}
                  </h1>
                  <p className="mb-3 text-xl text-gray-500">{person.name}</p>
                  <div className="moreButton">
                    <button
                      className="mt-2 border border-black px-4 py-1 text-black duration-150 ease-in-out hover:bg-black hover:text-white"
                      onClick={() => {
                        setSelectedItem(person);
                        setType("tutor");
                        setOpenDialog(true);
                      }}
                    >
                      รู้จักกับคุณครู <HiArrowUpRight className="inline" />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="sm:hidden">
            <OwlCarousel
              className="owl-theme alltutor overflow-hidden sm:hidden"
              items={1}
              nav
              navText={[
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>',
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>',
              ]}
            >
              {tutor.map((person) => (
                <div className="relative">
                  <img src={person.imageUrl} alt="" />
                  <div className="absolute bottom-0 max-w-xs rounded-xl bg-white p-2 shadow-lg sm:bottom-10 sm:left-14 sm:p-5">
                    <p className="max-w-max rounded-full bg-purple-500 px-2 text-lg text-white">
                      {person.subject}
                    </p>

                    <h1 className="mt-3 text-2xl font-extrabold text-gray-800 sm:text-4xl">
                      {person.nickname}
                    </h1>
                    <p className="mb-3 text-xl text-gray-500">{person.name}</p>
                    <div className="hidden sm:inline-block ">
                      <button
                        className="mt-2 border border-black px-4 text-black duration-150  ease-in-out hover:bg-black hover:text-white"
                        onClick={() => {
                          setSelectedItem(person);
                          setType("tutor");
                          setOpenDialog(true);
                        }}
                      >
                        รู้จักกับคุณครู <HiArrowUpRight className="inline" />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </OwlCarousel>
          </div>
        </div>
      </div>
      <div className="bg-slate-100 py-24 sm:py-32 ">
        <div
          className={`mx-auto px-6 lg:px-8 max-h-${boxHeight} overflow-hidden`}
        >
          <div className="mx-auto max-w-7xl">
            <h2 className="  my-5 max-w-max  rounded-full bg-white px-5 py-1  text-2xl font-extrabold  text-purple-500">
              Learning Experience
            </h2>
            <p className="mt-2 max-w-xl text-6xl font-extrabold leading-tight tracking-tight text-gray-800 sm:max-w-md sm:text-7xl 2xl:max-w-xl 2xl:text-8xl">
              ประสบการณ์ในการเรียน
            </p>
          </div>

          <Gallery />
        </div>
      </div>
      <Modal
        isOpen={openDialog}
        selectedItem={selectedItem}
        type={type}
        handleClose={() => {
          setOpenDialog(false);
          setSelectedItem({});
        }}
      />
      <CTA />

      <Footer />
    </div>
  );
}
